import { render, staticRenderFns } from "./RequestTravel.vue?vue&type=template&id=29348df6&scoped=true"
import script from "./RequestTravel.vue?vue&type=script&lang=js"
export * from "./RequestTravel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29348df6",
  null
  
)

export default component.exports